import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { featuredArchive, focusArchive } from '@/mocks/home';

const sortTabs = ['按热度', '按时间', '按题材'];

export default function ArchiveSection() {
  const [activeTab, setActiveTab] = useState(sortTabs[0]);

  return (
    <section id="archive" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8 xl:px-10">
        <SectionHeading
          eyebrow="Hot Files"
          title="热门人物黑料档案"
          desc="按讨论热度排序的人物档案合辑，每位人物一份独立档案，串联争议起因、关键节点与后续回应，点开即可查看完整事件脉络。"
          action={
            <div className="inline-flex items-center rounded-full bg-background-100 p-1">
              {sortTabs.map((tab) => (
                <button
                  key={tab}
                  type="button"
                  onClick={() => setActiveTab(tab)}
                  className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 font-label text-sm transition-colors ${
                    activeTab === tab
                      ? 'bg-foreground-950 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          }
        />

        <article className="hlw-reveal mt-10 grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:grid-cols-12">
          <div className="relative min-h-[240px] lg:col-span-5 lg:min-h-[320px]">
            <img
              src={focusArchive.cover}
              alt={`${focusArchive.name} 人物黑料档案封面`}
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 font-label text-xs font-medium text-background-50">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-fire-line text-sm" />
              </span>
              本周焦点档案
            </span>
          </div>
          <div className="flex flex-col justify-between p-5 md:p-8 lg:col-span-7">
            <div>
              <div className="flex flex-wrap items-center gap-3 font-label text-xs text-foreground-500">
                <span className="rounded-sm bg-secondary-100 px-2 py-1 text-secondary-900">
                  {focusArchive.category}
                </span>
                <span>档案编号 {focusArchive.code}</span>
                <span className="text-foreground-300">|</span>
                <span>更新于 {focusArchive.updated}</span>
              </div>
              <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                {focusArchive.name} · {focusArchive.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                {focusArchive.summary}
              </p>
              <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2">
                {focusArchive.points.map((point) => (
                  <li key={point} className="flex items-center gap-2 text-sm text-foreground-700">
                    <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-600">
                      <i className="ri-checkbox-circle-line text-base" />
                    </span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-background-300/60 pt-5">
              <span className="flex items-center gap-4 font-label text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                    <i className="ri-fire-line text-sm" />
                  </span>
                  热度 {focusArchive.heat}
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                    <i className="ri-links-line text-sm" />
                  </span>
                  12 条信源
                </span>
              </span>
              <button
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                查看完整档案
              </button>
            </div>
          </div>
        </article>

        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {featuredArchive.map((item) => (
            <article
              key={item.code}
              className="hlw-reveal group relative aspect-[4/5] overflow-hidden rounded-lg border border-background-200 bg-foreground-950"
            >
              <img
                src={item.cover}
                alt={`${item.name} 黑历史合集封面`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />
              <div className="relative flex h-full flex-col justify-between p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <span className="rounded-full border border-white/25 bg-white/10 px-2.5 py-1 font-label text-[11px] text-white/85 backdrop-blur">
                    {item.category}
                  </span>
                  <span className="font-label text-[11px] text-white/60">{item.code}</span>
                </div>
                <div>
                  <h3 className="font-heading text-lg font-bold text-white md:text-xl">{item.name}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-white/75 md:text-[13px]">
                    {item.summary}
                  </p>
                  <div className="mt-4 flex items-center justify-between border-t border-white/15 pt-3 font-label text-[11px] text-white/65">
                    <span className="flex items-center gap-1.5">
                      <span className="flex h-4 w-4 items-center justify-center text-accent-300">
                        <i className="ri-fire-line text-sm" />
                      </span>
                      热度 {item.heat}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-time-line text-sm" />
                      </span>
                      {item.updated}
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-archive-drawer-line text-base" />
            加载更多人物档案
          </button>
        </div>
      </div>
    </section>
  );
}